import React from 'react';
import PageIsLoading from '../components/PageIsLoading';
import { useAuth } from 'react-oidc-context';

const Signin: React.FC = () => {
    const auth = useAuth();

    if (auth && auth.isAuthenticated) {
        console.info('User is authenticated, redirecting to /')
        location.replace('/');
    }

    return (
        <PageIsLoading />
    );
};

export default Signin;
